import { SOLICITUDES_WA } from '../actions/types';

const initialState = {
    listado: [],
    detalles: null
};

export default (state = initialState, action) => {

    const { type, payload } = action;

    switch (type) {
        case SOLICITUDES_WA.BUSCAR:
            return {
                ...state,
                listado: payload
            };

        case SOLICITUDES_WA.DETALLES:
            return {
                ...state,
                detalles: payload
            };

        case SOLICITUDES_WA.ASIGNAR:
            return {
                ...state,
                listado: state.listado.map(item =>
                    item._id === payload.id
                        ? { ...item, usuario: payload.usuario }
                        : item
                )
            };

        case SOLICITUDES_WA.STATUS:
            return {
                ...state,
                listado: state.listado.map(item =>
                    item._id === payload.id
                        ? { ...item, status: payload.status }
                        : item
                ),
                detalles: state.detalles?._id === payload.id
                    ? { ...state.detalles, status: payload.status }
                    : state.detalles
            };

        case SOLICITUDES_WA.CONVERTIR:
            return {
                ...state,
                listado: state.listado.map(item =>
                    item._id === payload.id
                        ? { ...item, status: 1, asesoria: payload.asesoria }
                        : item
                ),
                detalles: state.detalles?._id === payload.id
                    ? { ...state.detalles, status: 1, asesoria: payload.asesoria }
                    : state.detalles
            };

        case SOLICITUDES_WA.ELIMINAR:
            return {
                ...state,
                listado: state.listado.filter(item => item._id !== payload)
            };

        default:
            return state;
    }
}
